import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-maintenance',
  templateUrl: './convenant-maintenance.component.html'
})
export class ConvenantMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
